<template lang="pug">
  div.calculation.regional-tariff-view
    e-form-modal(
    ref="modalForm"
    @submitModalForm="submitModalForm()"
    @deleteItem="() => ({})"
    :hideDeleteButton="false"
    saveBtnLabel="Перейти в таблицу"
    savingBtnLabel="Перейти в таблицу"
    )
      div(slot="header")
        e-breadcrumbs
        h1.title
          template Расчет Единого тарифа на услугу Регионального оператора на 1-ый год действия Соглашения
        e-steps(
        :steps="regionalTariffSteps"
        :activeIndex="1"
        )
      slot
        div.body-wrapper
          div.body
            div.col
             div.center-row-wrapper
              div.center-row
                label Собственные расходы РО:
                div {{fields.own_expenses}}
              div.center-row
                label Расходы на обезвреживание и захоронение:
                div {{fields.burial_costs}}
              div.center-row
                label Объем отходов:
                div {{fields.v_waste}}
              div.center-row
                label Масса отходов:
                div {{fields.m_waste}}
              div.center-row
                label Единный тариф на услугу РО (руб/тонна):
                div {{fields.tariff_result}}
              div.center-row
                label Единный тариф на услугу РО (руб/куб.м.):
                div  {{fields.tariff_result_volume}}

</template>

<script>
  import {mongoApi} from '../../api/api-endpoints.js'
  import {CalculationRegionalTariffs} from '../../config/mongo'
  import regionalTariffViewMixin from './mixins/regional-tariff-view-mixin.js'

  export default {
    mixins: [regionalTariffViewMixin],
    methods: {
      getItemEndpoint (route) {
        return mongoApi.getCollectionItem(CalculationRegionalTariffs, route.params.id)
      }
    }
  }
</script>
